<template>
  <div id="item">
    <div class="page-title"></div>

    <Panel :title="$t('inventory.upload_file')"  collapsible>
      <template>
        <TipBox info :title="$t('external_pos.md_upload')">
          <div v-html="$t('external_pos.md_upload_description')"></div>
          <ul>
            <li><b>{{$t('external_pos.path')}}:</b>  C:/POSERA/MaitreD/DATA/ConfigExport.xml</li>
          </ul>
        </TipBox>
      </template>
      <div class="top">
        <label class="text-reader">
          <input type="file" @change="loadTextFromFile">
        </label>
        <br/>
        <button class="save btn btn-primary" @click="uploadXml">{{$t("external_pos.upload")}}</button>
      </div>
    </Panel>

    <Panel v-if="xmlUploaded" :title="$t('external_pos.synchronization')"  collapsible>
      <template>
        <TipBox info no-border :title="$t('external_pos.synchronization_info')"></TipBox>
        <TipBox danger no-border :title="$t('external_pos.synchronization_warning')"></TipBox>
        <div v-if="isUberEatsActivated" >
          <input id="forceUberEatsPriceUpdate" type="checkbox" v-model="data.forceUberEatsPriceUpdate">
          <label for="forceUberEatsPriceUpdate">{{$t('external_pos.force_uber_eats_price_pdate')}}</label>
        </div>
      </template>
      <div class="command">
        <br/>
        <button class="save btn btn-primary" @click="runCommand">{{$t("external_pos.sync")}}</button>
      </div>
    </Panel>

    <Panel v-if="isReportGenerated" :title="$t('external_pos.persist_change')"  collapsible>
      <div class="command">
        <TipBox danger :title="$t('external_pos.persist_change_info')">
          <b>{{$t('external_pos.persist_change_warning')}}</b>
        </TipBox>
        <input id="saveConfirm" type="checkbox" v-model="data.save">
        <label for="saveConfirm">{{$t('external_pos.save_price_change')}}</label>
        <br/>
        <button class="save btn btn-primary" @click="confirmPersistPrice">{{$t("confirm")}}</button>
      </div>
    </Panel>


    <Panel title="Rapport" collapsible>
      <table class="report">
        <tr>
          <th>{{$t('external_pos.mode')}}</th>
          <th>{{$t('external_id')}}</th>
          <th>{{$t('external_pos.price')}}</th>
          <th>{{$t('external_pos.description')}}</th>
          <th>{{$t('external_pos.type')}}</th>
          <th>{{$t('external_pos.id')}}</th>
          <th>{{$t('external_pos.external_price')}}</th>
          <th>{{$t('external_pos.external_description')}}</th>
          <th>{{$t('external_pos.external_function')}}</th>

        </tr>
        <tr v-for="item of items">
          <td>{{ item.mode }}</td>
          <td>{{ item.externalId }}</td>
          <td>{{ item.ishopFoodPrice }}</td>
          <td>{{ item.ishopFoodDescription }}</td>
          <td>{{ item.ishopFoodType }}</td>
          <td>{{ item.mdProductId }}</td>
          <td>{{ item.mdPrice }}</td>
          <td>{{ item.mdDescription }}</td>
          <td>{{ item.mdFunction }}</td>
        </tr>
      </table>
      <br/> <br/>

      <Panel :title="$t('external_pos.changes_to_save')" v-if="itemsWithPriceToUpdate" >
        <table class="report" >
          <tr>
            <th>{{$t('external_pos.mode')}}</th>
            <th>{{$t('external_id')}}</th>
            <th>{{$t('external_pos.description')}}</th>
            <th>{{$t('external_pos.external_description')}}</th>
            <th>{{$t('external_pos.price')}}</th>
            <th>{{$t('external_pos.upcoming_price')}}</th>
            <th>{{$t('external_pos.type')}}</th>
            <th>{{$t('external_pos.external_function')}}</th>
          </tr>
          <tr v-for="item of itemsWithPriceToUpdate">
            <td>{{ item.method }}</td>
            <td>{{ item.externalId }}</td>
            <td>{{ item.ishopName }}</td>
            <td>{{ item.externalName }}</td>
            <td>{{ item.currentPrice }}</td>
            <td>{{ item.upcomingPrice[0] }}</td>
            <td>{{ item.type }}</td>
            <td>{{ item.externalFunction }}</td>
          </tr>
        </table>
      </Panel>

      <Panel :title="$t('external_pos.items_not_found')" v-if="itemsNotFoundInPos" >
        <table class="report">
          <tr>
            <th>{{$t('external_id')}}</th>
            <th>{{$t('external_pos.description')}}</th>
            <th>{{$t('external_pos.type')}}</th>
          </tr>
          <tr v-for="item of itemsNotFoundInPos">
            <td>{{ item.externalId }}</td>
            <td>{{ $to(item.name) }}</td>
            <td>{{ item.type }}</td>
          </tr>
        </table>
      </Panel>

      <Panel title="Item sans id externee" v-if="itemsWithNoExternalId" >
        <table class="report">
          <tr>
            <th>{{$t('external_pos.description')}}</th>
            <th>{{$t('external_pos.type')}}</th>
          </tr>
          <tr v-for="item of itemsWithNoExternalId">
            <td>{{ $to(item.name) }}</td>
            <td>{{ item.type }}</td>
          </tr>
        </table>
      </Panel>

    </Panel>

    <Panel v-if="syncResult" title="Logs" collapsible>

      <div id="result">
        <div v-html="syncResult"></div>
      </div>

    </Panel>

    <Modal
        name="no-file-error"
        :title="$t('error.title')"
        :actions="[{name: $t('back'), action: 'close'}]">
        {{$t('external_pos.file_required')}}
    </Modal>

    <Modal
        name="save-price-error"
        :title="$t('error.title')"
        :actions="[{name: $t('back'), action: 'close'}]">
        {{$t('external_pos.confirm_price_change')}}
    </Modal>

  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: "MaitreDSync",

    data() {
      return {
        companyId: null,
        branchId: null,
        syncResult: null,
        isUberEatsActivated: null,
        data: {
          xml: null,
          save: false,
          forceUberEatsPriceUpdate: false,
          locale: this.$ts.state.locale,
        },
        xmlUploaded: false,
        isReportGenerated: false,
        items: [],
        itemsWithPriceToUpdate: null,
        itemsNotFoundInPos: null,
        itemsWithNoExternalId: null,
      }
    },

    mounted() {
      this.companyId = this.$route.query.company;
      this.branchId = this.$route.query.branch;
      this.$store.state.pageTitleTranslationKey = "inventory.pos_price_sync";
      this.$store.state.pageIcon = "/icon/update.svg";
    },

    methods: {
      ...mapActions(['uploadXmlForMaitreDExternalPos', 'syncFromXmlForMaitreDExternalPos', 'generateReportForMaitreDExternalPos']),

      loadTextFromFile(ev) {
        const file = ev.target.files[0];
        const reader = new FileReader();
        reader.onload = e => this.data.xml = e.target.result;
        reader.readAsText(file);
      },

      async uploadXml() {
        if(!this.data.xml) {
          this.$modal.show('no-file-error');
          return;
        }

        showSpinner();
        let response = await this.uploadXmlForMaitreDExternalPos({
          branchId: this.branchId,
          companyId: this.companyId,
          data: this.data
        });
        hideSpinner();
        if (response) {
          toast(this.$t("success"), "success");
          this.xmlUploaded = true;
          this.isUberEatsActivated = response.isUberEatsActivated;
        } else {
          toast(this.$t("error.title"), "error");
        }
      },

      async runCommand() {
        showSpinner();
        let response = await this.syncFromXmlForMaitreDExternalPos({
          branchId: this.branchId,
          companyId: this.companyId,
          data: this.data
        });
        hideSpinner();

        if (response) {
          this.syncResult = response.prices_sync_logs;
          let reportJson = JSON.parse(response.report_json);
          this.itemsWithPriceToUpdate = response.itemsWithPriceToUpdate;
          this.itemsNotFoundInPos = response.itemsNotFoundInPos;
          this.itemsWithNoExternalId = response.itemsWithNoExternalId;
          this.items = reportJson['mdItems'];

        }
        this.isReportGenerated = true;
      },

      confirmPersistPrice() {
       if (!this.data.save) {
         this.$modal.show("save-price-error");
       } else {
         this.runCommand()
       }
      },

      generateReport() {
        console.log(this.xml);
        showSpinner();
        this.generateReportForMaitreDExternalPos({
          branchId: this.branchId,
          companyId: this.companyId,
          data: this.data
        }).then(r => {
            this.syncResult = r.prices_sync_logs;
            let reportJson = JSON.parse(r.report_json);
            this.items = reportJson['mdItems'];
            console.log(r)
          })
          .catch(e => {
            console.log(e);
            toast(this.$t("error.title"), "error");
          })
          .finally(() => {
            toast(this.$t("success"), "success");
            hideSpinner();
          })
      },

    }
  }
</script>

<style lang="scss" scoped>
  .report {
    width: 100%;
    td, th {
      padding: 4px 4px;
      text-align: left;
    }
    th {
      white-space: nowrap;
      background-color: #ddd;
    }
    tr:nth-child(odd) {
      background-color: #eee;
    }
    tr {
      page-break-inside: avoid;
    }
  }
</style>